"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");
/**
 * A comunica Ask Query Operation Actor.
 */


var ActorQueryOperationAsk =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationAsk, _bus_query_operation_);

  function ActorQueryOperationAsk(args) {
    _classCallCheck(this, ActorQueryOperationAsk);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationAsk).call(this, args, 'ask'));
  }

  _createClass(ActorQueryOperationAsk, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pattern, context) {
        var output, bindings, booleanResult;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.mediatorQueryOperation.mediate({
                  operation: pattern.input,
                  context: context
                });

              case 2:
                output = _context2.sent;
                bindings = bus_query_operation_1.ActorQueryOperation.getSafeBindings(output);
                booleanResult = new Promise(function (resolve, reject) {
                  // Resolve to true if we find one element, and close immediately
                  bindings.bindingsStream.once('data', function () {
                    resolve(true);
                    bindings.bindingsStream.close();
                  }); // If we reach the end of the stream without finding anything, resolve to false

                  bindings.bindingsStream.on('end', function () {
                    return resolve(false);
                  }); // Reject if an error occurs in the stream

                  bindings.bindingsStream.on('error', reject);
                });
                return _context2.abrupt("return", {
                  type: 'boolean',
                  booleanResult: booleanResult
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return ActorQueryOperationAsk;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationAsk = ActorQueryOperationAsk;